import { render, staticRenderFns } from "./DueDataTable.vue?vue&type=template&id=3a61677e&scoped=true"
import script from "./DueDataTable.vue?vue&type=script&lang=js"
export * from "./DueDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61677e",
  null
  
)

export default component.exports